import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-accountant-collection-cash',
  standalone: true,
  templateUrl: '../../assets/accountant-collection-cash.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamAccountantCollectionCashIcon {}
